// surovinaShoda.js — hledání suroviny v jídelníčku podle kořene slova (21.9.2026).
//
// Nutriční píše surovinu v 1. pádě („žitný chléb"), v receptu ale stojí
// „žitného chleba" nebo „žitným chlebem". Porovnání přesného textu to
// nenašlo (feedback #119). Teď se u každého hledaného slova odřízne česká
// koncovka a hledá se slovo v surovině, které tímhle kořenem začíná.
// Stejná logika je i na serveru (netlify/functions/_lib/surovinaShoda.cjs).

export const normSur = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");

const KONCOVKY = /(ovou|ymi|ami|emi|eho|ych|ymu|imu|ove|ovy|ova|ou|em|ym|mi|ho|ch|a|e|i|o|u|y)$/;

export function kmen(slovo) {
  const w = normSur(slovo);
  if (w.length <= 4) return w;
  const bez = w.replace(KONCOVKY, "");
  return bez.length >= 3 ? bez : w.slice(0, 3);
}

// true, když surovina (text) obsahuje všechna slova hledaného výrazu.
export function obsahujeSurovinu(text, hledane) {
  const slova = normSur(hledane).split(/[^a-z0-9]+/).filter((w) => w.length >= 2);
  if (!slova.length) return false;
  const vText = normSur(text).split(/[^a-z0-9]+/).filter(Boolean);
  return slova.every((q) => {
    const k = kmen(q);
    return vText.some((w) => w.startsWith(k));
  });
}
